import script from "./BaseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseForm.vue?vue&type=script&setup=true&lang=js"

import "./BaseForm.vue?vue&type=style&index=0&id=1316407e&lang=css"

const __exports__ = script;

export default __exports__